import { Page } from '@/components/page';
import { PricingPlans } from '@/components/pricing-plans';

export function Plans() {
  return (
    <Page title="Plans">
      <PricingPlans />
    </Page>
  );
}